import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";

const Layout = () => {
  return (
    <div className="layout">
      <Outlet /> {/* This renders the current page content */}
      <Footer />  {/* Footer always appears at the bottom */}
      <WhatsAppButton />
    </div>
  );
};

export default Layout;